import { render } from "./SetPagesJsonViewerModal.vue?vue&type=template&id=53c27788"
import script from "./SetPagesJsonViewerModal.vue?vue&type=script&lang=js"
export * from "./SetPagesJsonViewerModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__